export default __webpack_public_path__ + "static/media/nuts_level_1.b62949f4.geojson";